module.exports = __webpack_public_path__ + "static/022-983406c77ba8717726476e22231c87e6.jpg";